module.exports = __webpack_public_path__ + "static/media/WechatIMG187.16cd3ae4.jpeg";